import {
    BoxBufferGeometry,
    CatmullRomCurve3,
    CubeTextureLoader,
    InstancedBufferAttribute,
    InstancedBufferGeometry,
    Mesh,
    PerspectiveCamera,
    PointLight,
    Quaternion,
    Scene,
    Vector3,
    WebGLRenderer
} from "three"
//import TrackballControls from "three-trackballcontrols"
import Stats from "three-webgl-stats"
import raf from "raf"

import SimplexNoise from "simplex-noise"

import plateMaterial from "./plate-material"
import shieldMaterial from "./shield-material"

import GLTFLoader from "three-gltf-loader"
import createPath from "./createPath";
import getCurveLength from "./getCurveLength";


function findChild(scene, name)
{
    const { children } = scene;
    for (let i = 0; i < children.length; i++)
    {
        const kid = children[i];
        if (kid.name === name)
        {
            return kid;
        }
    }
}


function updateVertices()
{

}

const MAIN_NOISE_FACTOR = 0.000003;

const TAU = Math.PI * 2;

const MOUSE_SENSITIVITY = 0.1;

const RADIUS = 1200;

const TILE_SIZE = 350;
const TILE_SPACING = TILE_SIZE * 1.4;
const TILE_SPACING_RING = TILE_SIZE;

const SIZE = 640000;

const DISTURBANCE = 0.3;

const noise = new SimplexNoise();

let isMouseLocked = false;
let position = 0;

let spaceShipX = 0;
let spaceShipY = 0;

let spaceShipDx = 0;
let spaceShipDy = 0;

let plateMesh;

window.addEventListener("load", () => {

    const WIDTH = window.innerWidth,
        HEIGHT = window.innerHeight,
        FOV = 35,
        NEAR = 1,
        FAR = 100000;

    const renderer = new WebGLRenderer({
        antialias: true
    });
    renderer.setSize(WIDTH, HEIGHT);
    document.getElementById('host').appendChild(renderer.domElement);

    let stats;
    if (__STATS)
    {
        stats = new Stats();
        stats.domElement.style.position = 'absolute';
        stats.domElement.style.top = '0';
        document.body.appendChild(stats.domElement);
    }

    const camera = new PerspectiveCamera(FOV, WIDTH / HEIGHT, NEAR, FAR);
    const yPos = 0;
    camera.position.y = yPos;
    camera.position.z = 250;
    camera.lookAt(0,yPos,-1000)


    // const trackballControl = new TrackballControls(camera, renderer.domElement);
    // trackballControl.rotateSpeed = 5.0; // need to speed it up a little

    const scene = new Scene();

    // Instantiate a loader
    var loader = new GLTFLoader();

    let spaceShip, shield;


    // Load a glTF resource
    loader.load(
        // resource URL
        "media/runabout1.glb",
        // called when the resource is loaded
        function ( gltf ) {

            console.log("IMPORTED SCENE", gltf.scene);
            console.log("Objects", gltf.scene.children.map(k => k.name));

            const curve = new CatmullRomCurve3(
                createPath(
                    [
                        new Vector3(0, 0,0),
                        new Vector3(0,  0,-SIZE),
                        new Vector3(SIZE,  0, -SIZE),
                        new Vector3(SIZE,SIZE, -SIZE)
                    ],
                    0.25,
                    3
                )
            );

            const curveLength = getCurveLength(curve, 2000);
            const curveTileLength = Math.floor(curveLength / TILE_SPACING);

            console.log("CURVE LENGTH = " + curveLength, "Tiles = ", curveTileLength, " times ", TILE_SPACING);

            spaceShip = findChild(gltf.scene, "Spaceship");

            shield = findChild(gltf.scene, "Shield");

            shield.material = shieldMaterial;

            syncShield();

            scene.add( gltf.scene );

            console.log("Delta", spaceShip.position.clone().sub(camera.position));

            // gltf.animations; // Array<THREE.AnimationClip>
            // gltf.scene; // THREE.Scene
            // gltf.scenes; // Array<THREE.Scene>
            // gltf.cameras; // Array<THREE.Camera>
            // gltf.asset; // Object

            const light = new PointLight(0xffffff, 1, Infinity);
            camera.add(light);

            scene.add(light);

            const cubeGeo = new InstancedBufferGeometry().copy(new BoxBufferGeometry( TILE_SIZE, TILE_SIZE/6, TILE_SIZE));
            //cubeGeo.maxInstancedCount = 8;

            const numTiles = Math.floor( TAU * RADIUS / TILE_SPACING_RING);
            const numRings = 400;

            function setQuatFromCurve(quat, t, step)
            {
                const pt0 = curve.getPointAt(t);
                const pt1 = curve.getPointAt(t + step * 2);

                const forward = pt1.sub(pt0).normalize();
                quat.setFromUnitVectors( new Vector3(0,0,-1), forward);

                return forward;
            }


            const cubePos = [];
            const rot = [];
            const tunnelPos = [];

            const quaternion = new Quaternion();

            const curveStep = 1 / curveTileLength;
            const halfStep = curveStep / 2;

            for (let i=0; i < numRings; i++)
            {
                const curvePos = i * curveStep;
                const pos = curve.getPointAt(curvePos);



                const forward = setQuatFromCurve(quaternion, curvePos, halfStep);

                for (let j=0; j < numTiles; j++)
                {
                    const rnd = noise.noise2D( j * 0.4,  i * 0.4);

                    const holes = 0.2;
                    if (rnd < 1 - holes * 2)
                    {
                        const angle = TAU / numTiles * j;

                        const dx = Math.cos( angle ) * RADIUS;
                        const dy = Math.sin( angle ) * RADIUS;
                        const ringPos = new Vector3(
                            dx,
                            dy,
                            0
                        ).applyQuaternion(quaternion);

                        const curr = pos.clone().add(ringPos);

                        cubePos.push(curr.x, curr.y, curr.z);
                        tunnelPos.push(curvePos);

                        const q2 = new Quaternion().setFromAxisAngle(
                            new Vector3(0,0,-1),
                            -angle + TAU/4
                        ).premultiply(quaternion);


                        rot.push(
                            q2.x,
                            q2.y,
                            q2.z,
                            q2.w
                        );



                    }

                }

                //pos.add(forward.clone().multiplyScalar(TILE_SIZE * 1.2));

                //console.log("POS",pos);
            }


            cubeGeo.addAttribute("cubePos", new InstancedBufferAttribute(
                new Float32Array(cubePos),
                3,
                false
            ));


            cubeGeo.addAttribute("rot", new InstancedBufferAttribute(
                new Float32Array(rot),
                4,
                false
            ));

            cubeGeo.addAttribute("tunnelPos", new InstancedBufferAttribute(
                new Float32Array(tunnelPos),
                1,
                false
            ));

            plateMesh = new Mesh(cubeGeo, plateMaterial);
            plateMesh.frustumCulled = false;

            scene.add(plateMesh);

            scene.background = new CubeTextureLoader()
                .setPath( 'media/' )
                .load( [
                    'purplenebula_rt.jpg',
                    'purplenebula_lf.jpg',
                    'purplenebula_up.jpg',
                    'purplenebula_dn.jpg',
                    'purplenebula_ft.jpg',
                    'purplenebula_bk.jpg'
                ] );


            // pointer lock object forking for cross browser
            const lockTarget = renderer.domElement;

            lockTarget.requestPointerLock = lockTarget.requestPointerLock ||
                                       lockTarget.mozRequestPointerLock;

            document.exitPointerLock = document.exitPointerLock ||
                                       document.mozExitPointerLock;

            lockTarget.onclick = function() {
                lockTarget.requestPointerLock();
            };

            // pointer lock event listeners

            // Hook pointer lock state change events for different browsers
            document.addEventListener('pointerlockchange', lockChangeAlert, false);
            document.addEventListener('mozpointerlockchange', lockChangeAlert, false);

            function lockChangeAlert() {
                if (document.pointerLockElement === lockTarget ||
                    document.mozPointerLockElement === lockTarget) {
                    console.log('The pointer lock status is now locked');
                    document.addEventListener("mousemove", updatePosition, false);
                    isMouseLocked = true;
                } else {
                    console.log('The pointer lock status is now unlocked');
                    document.removeEventListener("mousemove", updatePosition, false);
                    isMouseLocked = false;
                }
            }


            function syncShield()
            {
                const curveStep = 1 / curveTileLength;
                const halfStep = curveStep / 2;

                const quat = new Quaternion();
                setQuatFromCurve(quat, position, halfStep);


                const currRight = new Vector3(1,0,0).clone().multiplyScalar(spaceShipX);
                const currUp = new Vector3(0,1,0).clone().multiplyScalar(spaceShipY);

                spaceShip.setRotationFromQuaternion(quat);


                const pos = curve.getPointAt(position).add(currUp).add(currRight);

                spaceShip.position.copy(pos);
                shield.position.copy(pos);
                shield.setRotationFromQuaternion(quat);

                if (currUp.lengthSq() > 50 * 50)
                {
                    currUp.setLength(50);
                }

                const forward = curve.getPointAt(position + 20/ curveTileLength).sub(pos).setLength(-200);
                camera.position.set(
                    pos.x + forward.x - currUp.x,
                    pos.y + forward.y - currUp.y,
                    pos.z + forward.z - currUp.z
                );
                camera.lookAt(pos);

                if (plateMesh)
                {
                    plateMesh.material.uniforms.camerPos = camera.position;
                }

                //camera.setRotationFromQuaternion(quat);
            }

            function updatePosition(e) {

                spaceShipDx += e.movementX * MOUSE_SENSITIVITY;
                spaceShipDy -= e.movementY * MOUSE_SENSITIVITY;

                syncShield();
            }

            function render() {

                updateVertices();
                renderer.render(scene, camera);
                stats && stats.update(renderer);
            }

            function animate() {
                //trackballControl.update();

                render();

                if (isMouseLocked)
                {
                    spaceShipX += spaceShipDx;
                    spaceShipY += spaceShipDy;

                    spaceShipDx *= 0.9;
                    spaceShipDy *= 0.9;

                    position += (1 / curveTileLength) * 0.3;
                    syncShield();
                }

                raf(animate);
            }

            animate();


            console.log("ready");

        },
        // called while loading is progressing
        function ( xhr ) {

            console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );

        },
        // called when loading has errors
        function ( error ) {

            console.log( 'An error happened', error );

        }
    );


}, true);



